export interface DashboardDatePreset {
	id: string;
	label: string;
	getRange: () => {from: string; to: string};
}

export const CUSTOM_RANGE_ID = 'custom_range';

function toISODate(date: Date): string {
	return date.toISOString().split('T')[0]!;
}

function today(): Date {
	const d = new Date();
	d.setHours(0, 0, 0, 0);
	return d;
}

export const DASHBOARD_DATE_PRESETS: DashboardDatePreset[] = [
	{
		id: 'today',
		label: 'Today',
		getRange: () => {
			const d = toISODate(today());
			return {from: d, to: d};
		},
	},
	{
		id: 'last_7_days',
		label: 'Last 7 days',
		getRange: () => {
			const end = today();
			const start = new Date(end);
			start.setDate(start.getDate() - 6);
			return {from: toISODate(start), to: toISODate(end)};
		},
	},
	{
		id: 'last_30_days',
		label: 'Last 30 days',
		getRange: () => {
			const end = today();
			const start = new Date(end);
			start.setDate(start.getDate() - 29);
			return {from: toISODate(start), to: toISODate(end)};
		},
	},
	{
		id: 'last_90_days',
		label: 'Last 90 days',
		getRange: () => {
			const end = today();
			const start = new Date(end);
			start.setDate(start.getDate() - 89);
			return {from: toISODate(start), to: toISODate(end)};
		},
	},
	{
		id: 'year_to_date',
		label: 'Year to date',
		getRange: () => {
			const end = today();
			const start = new Date(end.getFullYear(), 0, 1);
			return {from: toISODate(start), to: toISODate(end)};
		},
	},
	{
		id: CUSTOM_RANGE_ID,
		label: 'Custom range',
		getRange: () => {
			const d = toISODate(today());
			return {from: d, to: d};
		},
	},
];
